import React from 'react';

import type { WidgetProps } from '@rjsf/utils';

import { Autocomplete, TextField } from '@mui/material';

import { FREQUENT_FLYER_AIRLINES } from '~/utils/travelPreferencesMapping';

const AIRLINE_OPTIONS = FREQUENT_FLYER_AIRLINES as unknown as Array<string>;

export default function FrequentFlyerAirlineWidget({
  id,
  label,
  value,
  disabled,
  readonly,
  rawErrors,
  onChange,
}: WidgetProps) {
  return (
    <Autocomplete
      freeSolo
      forcePopupIcon
      openOnFocus
      disabled={disabled || readonly}
      filterOptions={(airlines) => airlines}
      id={id}
      inputValue={value ?? ''}
      onInputChange={(_event, airline, reason) => {
        if (reason !== 'reset') {
          onChange(airline, undefined, id);
        }
      }}
      options={AIRLINE_OPTIONS}
      renderInput={(params) => <TextField {...params} error={Boolean(rawErrors?.length)} label={label} />}
      value={value || null}
    />
  );
}
